export default __webpack_public_path__ + "media/images/gallery/8-4bdd85dc08a368a607253002fb06bd35.jpg";